import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';

@Component({
  selector: 'app-dashboard-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, SidebarComponent, HeaderComponent],
  template: `
    <div class="app-container">
      <app-sidebar></app-sidebar>
      <div class="main-content">
        <app-header></app-header>
        <main class="content-wrapper">
          <router-outlet></router-outlet>
        </main>
      </div>
    </div>
  `,
  styles: [`
    .app-container {
      display: flex;
      min-height: 100vh;
    }
    .main-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-left: 260px;
      background-color: var(--content-bg);
      transition: background-color 0.3s ease;
    }
    .content-wrapper {
      padding: 1.5rem;
      flex: 1;
    }
    @media (max-width: 991px) {
      .main-content {
        margin-left: 0;
      }
    }
  `]
})
export class DashboardLayoutComponent {}

